import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  OrderApproverData,
  OrderApproversLookupData,
  OrderApproversLookupItem
} from '@models/shopping.model';
import { NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { TranslationPipe } from '@pipes/translation/translation.pipe';
import { ShoppingService } from '@services/shopping/shopping.service';
import {
  Observable,
  OperatorFunction,
  catchError,
  debounceTime,
  distinctUntilChanged,
  map,
  of,
  switchMap,
  tap
} from 'rxjs';
import { TdsTypeAheadComponent } from 'tangoe-design-system';

@Component({
  selector: 'ts-select-approvers',
  templateUrl: './select-approvers.component.html',
  imports: [CommonModule, TranslationPipe, TdsTypeAheadComponent]
})
export class SelectApproversComponent {
  @Input() approver: OrderApproverData;
  @Input() id: string | number;
  @Input() label: string;
  @Input() control: FormControl;
  @Output() select_approver: EventEmitter<any> = new EventEmitter();
  no_results_found: boolean = false;
  loading: boolean = false;
  input_format = (item: OrderApproversLookupItem) => item.person_name;
  result_format = (item: OrderApproversLookupItem) => {
    const employee_id = item.employee_id ? `${item.employee_id} -` : '';
    return `${employee_id} ${item.person_name} (${item.email})`;
  };

  constructor(private shopping_svc: ShoppingService) {}

  search: OperatorFunction<string, readonly OrderApproversLookupItem[]> = (
    term$: Observable<string>
  ) =>
    term$.pipe(
      debounceTime(100),
      tap(() => (this.loading = this.no_results_found = false)),
      distinctUntilChanged(),
      switchMap((term: string) => {
        if (term.length < 3) return of([]);

        this.loading = true;

        return this.shopping_svc
          .searchOrderApprovers(
            term,
            this.approver.type,
            this.approver?.allow_selection && this.approver?.approver_group_id
              ? this.approver.approver_group_id
              : null
          )
          .pipe(
            map((res: OrderApproversLookupData) => {
              this.loading = false;
              this.no_results_found = !res.items || res.items.length === 0;
              return res.items?.length > 0 ? res.items : [];
            }),
            catchError(() => {
              this.loading = false;
              return of([]);
            })
          );
      })
    );

  onSelectApprover(event: NgbTypeaheadSelectItemEvent<any>): void {
    this.select_approver.emit(event);
  }
}
